import { replaceUnderscores } from "~/common/utils";
import { RadioWithTextType } from "~/patients/utils/consultations/intakes";

export const formatRadioWithFreeTextAnswers = (answer: RadioWithTextType[]) =>
  answer.map(
    ({ value, extra_data }) =>
      `${replaceUnderscores(value)}${extra_data ? `, ${extra_data}` : ""}`,
  );
